import { Tabs, Tab, Box } from '@mui/material'
import { useTranslation } from 'react-i18next'
import React, { useState } from 'react'
import styles from './ExternProfessional.module.css'
import { ProfileTab } from './profile-tab/ProfileTab'
import { MarketplaceTab } from './marketplace-tab/MarketplaceTab'
import { SchedulesTab } from './schedules-tab/SchedulesTab'

export const UserNewExtern = () => {
  const { t } = useTranslation()

  const [tabIndex, setTabIndex] = useState<number>(0)
  const handleTabChange = (event: React.SyntheticEvent, newValue: number) => setTabIndex(newValue)

  return (
    <Box className={styles.parentContainer}>
      <Tabs
        value={tabIndex}
        onChange={handleTabChange}
        classes={{ indicator: styles.customIndicator, root: styles.customRootTabs }}
      >
        <Tab
          label={<span className={styles.tabStyle}>{t('userData')}</span>}
          className={`${tabIndex === 0 ? styles.tabActive : styles.tab}`}
        />
        <Tab
          label={<span className={styles.tabStyle}>{t('marketplaceData')}</span>}
          className={`${tabIndex === 1 ? styles.tabActive : styles.tab}`}
        />
        <Tab
          label={<span className={styles.tabStyle}>{t('scheduleConfiguration')}</span>}
          className={`${tabIndex === 2 ? styles.tabActive : styles.tab} ${styles.lastTab}`}
        />
      </Tabs>
      <Box>
        {tabIndex === 0 && <ProfileTab />}
        {tabIndex === 1 && <MarketplaceTab />}
        {tabIndex === 2 && <SchedulesTab />}
      </Box>
    </Box>
  )
}
